<template>
	<div class="layer-project" data-project-name="transys">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit"><br class="lb-m" />HYUNDAI TRANSYS</h1>
					<a href="http://www.hyundai-transys.com/" class="link" target="_blank"
						>www.hyundai-transys.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						현대다이모스-현대파워텍 기업 합병에 따른 현대트랜시스 PC 웹, 모바일
						통합 사이트를 구축한 프로젝트입니다. <br />합병에 따른
						현대트랜시스의 새로운 CI 변경, 콘텐츠 통합 및 신규 콘텐츠를
						제작하였고, Web Style Guide <br class="lb-t" />국문/영문/중문으로
						구성하였습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">HYUNDAI<br />DYMOS</li>
							<li class="item02">HYUNDAI<br />POWERTECH</li>
						</ul>
						<ul class="diagram02">
							<li class="item03">HYUNDAI<br />TRANSYS</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section section01 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">PC Web</strong>
						<p class="cont-desc">
							한 화면 안에 모든 콘텐츠가 구성되어 사용자의 편리성을 높일 수 있는
							구조로 구성하였습니다. 중앙에 키 비주얼을 두 가지로 구성하여
							시각적인 요소를 보여주고, 오른쪽 메뉴를 아이콘으로 구성하여
							사용자가 필요한 정보에 직관적으로 접근 할 수 있습니다.
						</p>
					</div>
					<div class="detail-img">
						<div class="detail-main-img max-limit">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec1-main-img@m.jpg"
							/>
						</div>
						<div class="mobile-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/transys/sec1-slide-img01@m.jpg"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/transys/sec1-slide-img02@m.jpg"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/transys/sec1-slide-img03@m.jpg"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/transys/sec1-slide-img04@m.jpg"
									/>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<section class="section section02 full">
				<div class="inner-section max-limit">
					<p class="cont-desc">
						메인에서 해당페이지로 이동 할 수 있게 퀵메뉴를 생성하여 사용자가
						사이트를 이탈하지 않고 편리하게 이용할 수 있도록 구성하였습니다.
					</p>
					<ul>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec2-img01@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec2-img02@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec2-img03@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec2-img04@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec2-img05@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/transys/sec2-img06@m.png"
								data-break="m-tw"
							/>
						</li>
					</ul>
				</div>
			</section>
			<section class="section section03 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">Mobile Web</strong>
						<p class="cont-desc bg-txt">
							TRANSFORM <br class="lb-m" />&amp; TRANSCEND
							<br class="lb-t" />MOTER SYSTEM
						</p>
					</div>
					<div class="detail-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/transys/sec3-content-img@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section04">
				<div class="inner-section">
					<ul class="detail-cont cont01">
						<li>
							<img
								src="/static/img/project-detail/transys/sec4-icon01@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/transys/sec4-icon02@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/transys/sec4-icon03@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/transys/sec4-icon04@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/transys/sec4-icon05@m.png"
								data-break="m-tw"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/transys/sec4-icon06@m.png"
								data-break="m-tw"
							/>
						</li>
					</ul>
					<ul class="detail-cont cont02">
						<li data-color="#00386f">#00386f</li>
						<li data-color="#0072bf">#0072bf</li>
						<li data-color="#3b73b9">#3b73b9</li>
						<li data-color="#9ba9be">#9ba9be</li>
						<li data-color="#333333">#333333</li>
						<li data-color="#6e7274">#6e7274</li>
					</ul>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">HYNDAI TRANSYS</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".mobile-swiper", {
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
						slidesPerView: 1,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
	methods: {},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
.layer-project-detail > section.full {
	padding-bottom: 0;
}
.section .cont-desc {
	word-break: keep-all;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
@media screen and (max-width: 711px) {
	.section.full .max-limit {
		padding: 0 15px;
	}
	.lb-m {
		display: block;
	}
	.lb-t {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	.section.full .max-limit {
		padding: 0 40px;
	}
	.lb-m {
		display: none;
	}
	.lb-t {
		display: block;
	}
}
@media screen and (min-width: 1280px) {
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.lb-t {
		display: none;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #00386f url(/static/img/project-detail/transys/ci.png) 50% / auto
		41px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/transys/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/transys/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/transys/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 80px;
	}
}

/* Overview */
.project-overview {
	background-color: #00386f;
	color: #fff;
}
.project-overview-diagram {
	display: flex;
	justify-content: center;
	margin-bottom: 8px;
}
.project-overview-diagram ul {
	position: relative;
	display: flex;
	justify-content: center;
}
.project-overview-diagram ul li {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	text-align: center;
	line-height: 1.2;
	letter-spacing: -0.025em;
}
.project-overview-diagram .diagram01 li {
	border: 1px solid #fff;
}
.project-overview-diagram .diagram01:before,
.project-overview-diagram .diagram01:after {
	content: "";
	position: absolute;
	right: 0;
	background-color: #fff;
}
.project-overview-diagram .diagram02 li {
	background-color: #fff;
	color: #00386f;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram {
		margin-top: 25px;
	}
	.project-overview-diagram ul li {
		width: 93px;
		height: 93px;
		font-size: 13px;
		line-height: 17px;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 15px;
	}
	.project-overview-diagram .diagram01 li:nth-child(1) {
		margin-right: -9px;
	}
	.project-overview-diagram .diagram01:before,
	.project-overview-diagram .diagram01:after {
		width: 14px;
		height: 1px;
	}
	.project-overview-diagram .diagram01:before {
		top: calc(50% - 5px);
		transform: rotate(45deg);
	}
	.project-overview-diagram .diagram01:after {
		top: calc(50% + 5px);
		transform: rotate(-45deg);
	}
	.project-overview-diagram .diagram02 {
		margin-left: 5px;
	}
	.project-overview-diagram .diagram02 li {
		font-size: 14px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		margin-top: 26px;
	}
	.project-overview-diagram ul li {
		width: 138px;
		height: 138px;
		font-size: 14px;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 68px;
	}
	.project-overview-diagram .diagram01 li:nth-child(1) {
		margin-right: -8px;
	}
	.project-overview-diagram .diagram01:before {
		display: none;
	}
	.project-overview-diagram .diagram01:after {
		width: 89px;
		height: 1px;
		top: 50%;
	}
	.project-overview-diagram .diagram02 {
		margin-left: 29px;
	}
	.project-overview-diagram .diagram02 li {
		font-size: 16px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-diagram {
		margin-top: 18px;
		margin-bottom: 15px;
	}
	.project-overview-diagram ul li {
		width: 230px;
		height: 230px;
		font-size: 20px;
		line-height: 1.8;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 208px;
	}
	.project-overview-diagram .diagram01 li:nth-child(1) {
		margin-right: -14px;
	}
	.project-overview-diagram .diagram01:before {
		display: none;
	}
	.project-overview-diagram .diagram01:after {
		width: 178px;
		height: 2px;
		top: 50%;
	}
	.project-overview-diagram .diagram02 {
		margin-left: 30px;
	}
	.project-overview-diagram .diagram02 li {
		font-size: 28px;
		line-height: 1.2;
	}
}
/* section01 : PC Web */
.section01 {
	position: relative;
	background-color: #ededed;
	z-index: 10;
}
.section01 .detail-img {
	position: relative;
}
.section01 .detail-img:before {
	position: absolute;
	bottom: 0;
	left: 0;
	content: "";
	width: 100%;
	background-color: #38414a;
}
.section01 .mobile-swiper .swiper-wrapper {
	flex-wrap: wrap;
}
@media screen and (max-width: 711px) {
	.section.full .detail-main-img.max-limit {
		padding: 0;
	}
	.section01 .detail-img {
		margin-top: 25px;
	}
	.section01 .detail-img:before {
		height: 133px;
	}
	.section01 .detail-main-img {
		width: 290px;
		margin: 0 auto;
		box-shadow: 0px 35px 30px 0px rgba(0, 0, 0, 0.1);
	}
	.section01 .mobile-swiper {
		position: relative;
		margin-top: 30px;
		padding-bottom: 34px;
		text-align: center;
	}
	.section01 .mobile-swiper .swiper-wrapper {
		flex-wrap: nowrap;
	}
	.section01 .mobile-swiper .swiper-slide {
		padding: 0 15px;
	}
	.section01 .mobile-swiper .swiper-slide img {
		width: 290px;
		box-shadow: 0px 17px 20px 0px rgba(0, 0, 0, 0.22);
	}
}
@media screen and (min-width: 712px) {
	.section01 .detail-img {
		margin-top: 27px;
	}
	.section01 .detail-img:before {
		height: 180px;
	}
	.section01 .detail-main-img img {
		width: 88.764vw;
		box-shadow: 0px 17px 20px 0px rgba(0, 0, 0, 0.22);
	}
	.section01 .mobile-swiper {
		padding: 0 40px;
	}
	.section01 .mobile-swiper .swiper-wrapper {
		justify-content: center;
		align-items: center;
		margin-top: 40px;
		padding-bottom: 30px;
	}
	.section01 .mobile-swiper .swiper-slide {
		width: 42.13vw;
		box-shadow: 0px 17px 20px 0px rgba(0, 0, 0, 0.22);
	}
	.section01 .mobile-swiper .swiper-slide:nth-child(odd) {
		margin-right: 20px;
	}
	.section01 .mobile-swiper .swiper-slide:nth-child(1) {
		margin-bottom: 40px;
	}
	.section01 .mobile-swiper .swiper-slide:nth-child(4) {
		margin-top: -100px;
	}
}
@media screen and (min-width: 1280px) {
	.section01 .detail-img {
		margin-top: 56px;
	}
	.section01 .detail-img:before {
		height: 400px;
	}
	.section01 .detail-main-img img {
		box-shadow: 0px 33px 40px 0px rgba(0, 0, 0, 0.22);
	}
	.section01 .mobile-swiper .swiper-wrapper {
		margin-top: 80px;
		padding-bottom: 54px;
	}
	.section01 .mobile-swiper .swiper-slide {
		width: 600px;
		box-shadow: 0px 33px 40px 0px rgba(0, 0, 0, 0.22);
	}
	.section01 .mobile-swiper .swiper-slide:nth-child(odd) {
		margin-right: 40px;
	}
	.section01 .mobile-swiper .swiper-slide:nth-child(1) {
		margin-bottom: 80px;
	}
	.section01 .mobile-swiper .swiper-slide:nth-child(4) {
		margin-top: -200px;
	}
}
/* section02 : Quick Menu */
.section02 {
	position: relative;
	background-color: #38414a;
}
.section02 .cont-desc {
	color: #fff;
}
.section02 ul {
	display: flex;
	justify-content: center;
	align-items: center;
}
.section02 ul li {
	display: block;
	text-align: center;
}
.section02 ul li img {
	box-shadow: 0px 17px 20px 0px rgba(0, 0, 0, 0.22);
}
@media screen and (max-width: 711px) {
	.section02 ul {
		flex-wrap: wrap;
		padding: 25px 0;
	}
	.section02 ul li {
		width: 27.031vw;
		height: auto;
		margin: 0 15px 15px 0;
	}
	.section02 ul li:nth-child(3n) {
		margin-right: 0;
	}
}
@media screen and (min-width: 712px) {
	.section02 ul {
		padding: 35px 0;
		justify-content: center;
	}
	.section02 ul li {
		width: 12.148vw;
		margin-right: 24px;
	}
	.section02 ul li:last-child {
		margin-right: 0;
	}
}
@media screen and (min-width: 1280px) {
	.section02 ul {
		padding: 70px 0;
		justify-content: space-between;
	}
	.section02 ul li {
		width: 173px;
		height: 165px;
	}
}
/* section03 : Mobile Web */
.layer-project-detail > .section03 {
	padding-top: 12px;
}
.section03 {
	position: relative;
	background-color: #38414a;
}
.section03 .project-subtit {
	color: #fff;
}
.section03 .cont-desc {
	color: rgba(255, 255, 255, 0.05);
	font-weight: 500;
	letter-spacing: -0.5px;
	line-height: 1.12;
}
@media screen and (max-width: 711px) {
	.section03 .cont-desc {
		font-size: 40px;
	}
	.section03 .detail-img {
		margin-top: -15px;
	}
	.section03 .detail-img img {
		width: 100%;
	}
}
@media screen and (min-width: 712px) {
	.section03 .cont-desc {
		font-size: 50px;
	}
	.section03 .detail-img {
		position: relative;
		margin-top: 30px;
	}
	.section03 .detail-img:before {
		position: absolute;
		bottom: 0;
		left: 0;
		content: "";
		width: 100%;
		height: 140px;
		background-color: #fff;
	}
	.section03 .detail-img img {
		position: relative;
		z-index: 10;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .cont-desc {
		font-size: 100px;
		margin-top: 75px;
		letter-spacing: -4px;
	}
	.section03 .detail-img:before {
		height: 320px;
	}
}
/* section04 : Design Identity */
.section04 ul {
	display: flex;
	justify-content: center;
	align-items: center;
}
.section04 ul li {
	text-align: center;
}
.section04 .cont02 li {
	display: block;
}
.section04 .cont02 li:before {
	content: "";
	display: block;
	border-radius: 50%;
	margin: 0 auto;
	text-align: center;
}
.section04 .cont02 li[data-color="#00386f"]:before {
	background-color: #00386f;
}
.section04 .cont02 li[data-color="#0072bf"]:before {
	background-color: #0072bf;
}
.section04 .cont02 li[data-color="#3b73b9"]:before {
	background-color: #3b73b9;
}
.section04 .cont02 li[data-color="#9ba9be"]:before {
	background-color: #9ba9be;
}
.section04 .cont02 li[data-color="#333333"]:before {
	background-color: #333333;
}
.section04 .cont02 li[data-color="#6e7274"]:before {
	background-color: #6e7274;
}
@media screen and (max-width: 711px) {
	.section04 ul {
		flex-wrap: wrap;
	}
	.section04 ul li {
		width: 33.3%;
	}
	.section04 .cont01 li {
		padding: 12px 26px;
	}
	.section04 .cont01 li img {
		width: 42px;
		height: 35px;
	}
	.section04 .cont02 li {
		padding: 12px 22px;
		font-size: 14px;
	}
	.section04 .cont02 li:before {
		width: 45px;
		height: 45px;
	}
}
@media screen and (min-width: 712px) {
	.section04 ul {
		padding: 0 10px;
		justify-content: space-between;
		margin-bottom: 35px;
	}
	.section04 ul li {
		width: 50px;
	}
	.section04 .cont01 li img {
		width: 32px;
		height: 27px;
	}
	.section04 .cont02 li {
		font-size: 12px;
	}
	.section04 .cont02 li:before {
		width: 45px;
		height: 45px;
		margin: 0 auto 8px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		padding: 40px 0;
	}
	.section04 ul {
		padding: 0 20px;
		margin-bottom: 80px;
	}
	.section04 ul li {
		width: 90px;
	}
	.section04 .cont01 li img {
		width: 65px;
		height: 54px;
	}
	.section04 .cont02 li {
		font-size: 16px;
	}
	.section04 .cont02 li:before {
		width: 90px;
		height: 90px;
		margin: 0 auto 15px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/transys.vue